{
  "title": "Otiluke's Resilient Sphere",
  "source": "Player's Handbook",
  "levelAndSchool": "4th-level evocation",
  "level": 4,
  "castingTime": "1 action",
  "range": "30 feet",
  "components": "V, S, M (a hemispherical piece of clear crystal and a matching hemispherical piece of gum arabic)",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "A sphere of shimmering force encloses a creature or object of Large size or smaller within range. An unwilling creature must make a Dexterity saving throw. On a failed save, the creature is enclosed for the duration.",
    "Nothing – not physical objects, energy, or other spell effects – can pass through the barrier, in or out, though a creature in the sphere can breathe there. The sphere is immune to all damage, and a creature or object inside can’t be damaged by attacks or effects originating from outside, nor can a creature inside the sphere damage anything outside it.",
    "The sphere is weightless and just large enough to contain the creature or object inside. An enclosed creature can use its action to push against the sphere’s walls and thus roll the sphere at up to half the creature’s speed. Similarly, the globe can be picked up and moved by other creatures.",
    "A Disintegrate spell targeting the globe destroys it without harming anything inside it."
  ],
  "spellLists": ["artificer", "eldritch-knight", "wizard"]
}
